/*
 * @providesModule MatchesStore
 */

import RESTStore from 'RESTStore';
import Match from 'SKZMatch';
import CurrentUserStore from 'CurrentUserStore';
import _ from 'lodash';

import {NativeModules} from 'react-native';
const SKZAPIManager = NativeModules.SKZAPIManager;

const MAX_STREAM_RETRIES = 3;

export default class MatchesStore {
  static isRefreshing: boolean;
  static _data: Object | null;
  static _isRefreshing: boolean;

  static getData() {
    if (this._data) {
      const matchList: Match[] = [];
      _.forEach(this._data, (match) => {
        let matchObj = new Match(match);
        matchList.push(matchObj);
      });
      return matchList;
    } else {
      return null;
    }
  }

  static clearMatchesCache() {
    this._data = null;
  }

  static _handleMatchStreamResponse(response: Object, completion: () => {}, retryCount: number) {
    console.debug('MS: got server response, process');
    if (response) {
      console.debug('MS: got good server response, call completion: ' + JSON.stringify(response));
      setTimeout(() => {
        this._isRefreshing = false;
      }, 5000);
      this._data = response;
      completion();
    } else if (retryCount < MAX_STREAM_RETRIES) {
      console.debug('MS: no good server response, wait and retry');
      setTimeout(() => {
        this.fetchMatches(completion, retryCount + 1);
      }, 200);
    } else {
      console.debug('MS: no good server response, too many retries, bail');
      setTimeout(() => {
        this._isRefreshing = false;
      }, 5000);
      completion();
    }
  }

  static fetchMatches(completion: () => {}, retryCount: number) {
    console.debug('MS: fetch match stream');
    if (!this._isRefreshing) {
      console.debug('MS: Not refreshing, continue');
      this._isRefreshing = true;
      CurrentUserStore.getUserData(true)
        .then((user: Object) => {
          const userId = _.get(user, 'id');
          if (!userId) {
            console.debug('MS: No user id');
            if (retryCount < MAX_STREAM_RETRIES) {
              console.debug('MS: Under retry count, wait 200ms, and retry');
              setTimeout(() => {
                this.fetchMatches(completion, retryCount + 1);
              }, 200);
            } else {
              console.debug('MS: too many retries, no username, bail out');
              this._isRefreshing = false;
              completion();
            }
          } else {
            console.debug('MS: got username, make server call');
            RESTStore.getServerResponse('users/' + userId + '/matches', null, true, (response) => {
              this._handleMatchStreamResponse(response, completion, retryCount);
            });
          }
        })
        .catch((error: unknown) => {
          this._isRefreshing = false;
          if (completion) {
            completion();
          }
        });
    } else {
      console.debug('MS: is refreshing, bail out');
      if (completion) {
        completion();
      }
    }
  }
}
